export class CustomAlias {
    id : number;
    screeningId : number
    screeningToken : string;
    firstName : string;
    lastName : string;
    middleName : string;
    //screeningId ?
    notes : string;
    ssn : string;
    dob : Date;
}